import { render, staticRenderFns } from "./group.vue?vue&type=template&id=2f198f09&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=2f198f09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.6_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6._v3ikegxpyohwicxz2xngozg43i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f198f09",
  null
  
)

export default component.exports